export default function Footer() {
    return (
        <div className="d-flex flex-row align-items-end justify-content-end mx-3 my-2">
            <p className="text-secondary">Beta</p>
        </div>
    )
}